// Copyright (c) Move Closer 2022.

import { Model } from '@movecloser/front-core'

import { OrderData } from '../../../contexts/orders/contracts/orders'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl> (edited)
 */
export class Order extends Model<OrderData> {
  protected boot (): void {
    this.initialValues = {}
    this.modelProperties = [
      'billingAddress',
      'carrier',
      'createdAt',
      'id',
      'paymentMethod',
      'products',
      'productsCost',
      'productSkus',
      'shippingAddress',
      'shippingCost',
      'shippingMethod',
      'status',
      'statusCode',
      'statusDetails',
      'total',
      'totalCost',
      'updatedAt'
    ]
  }
}
